module.exports = __webpack_public_path__ + "img/banner.3230e208.jpg";